import type { TWsMessage } from '../chat-websocket.types';
import { CHAT_UNREAD_CHANGED_EVENT } from './chat-websocket.constants';

/**
 * Avisa o Header (shared-ui), que tem socket próprio, que o total de não-lidas mudou
 * por uma leitura local — pra ele re-buscar e o badge acompanhar. Evento global; o
 * Header escuta o mesmo CHAT_UNREAD_CHANGED_EVENT. ANCR-5329.
 */
export function notifyHeaderUnreadChanged(): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(CHAT_UNREAD_CHANGED_EVENT));
}

/** Faz parse de uma string JSON recebida do WebSocket em um objeto de mensagem tipado. */
export function parseWsMessage(raw: string): TWsMessage | null {
  try {
    const parsed: unknown = JSON.parse(raw);
    if (typeof parsed === 'object' && parsed !== null && 'action' in parsed) {
      return parsed as TWsMessage;
    }
    return null;
  } catch {
    return null;
  }
}

/** Calcula o delay de reconexão com backoff linear limitado ao máximo de tentativas. */
export function calculateRetryDelay(tries: number, maxTries: number, delayUnitMs: number): number {
  return Math.min(tries, maxTries) * delayUnitMs;
}
